module.exports = __webpack_public_path__ + "static/media/invlogo.217313ac.png";